import { makeStyles } from '@material-ui/core';
import techneLogo from './assets/techne-logo.png';

const useStyles = makeStyles({
  logo: {
    width: 28,
    height: 28,
    borderRadius: 6,
    display: 'block',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.logo} src={techneLogo} alt="Techne" />;
};
